module.exports = __webpack_public_path__ + "static/img/icon-check-unknown.6374fc1b.png";